<template>
    <MainContent>
        <template v-slot:header>
            <PageTitle title="Detalles del equipo"></PageTitle>
        </template>
        <template v-slot:content>
            <div class="table-responsive has-options">
                <b-table hover :items="items" :fields="fields_equipos" id="equipos-table">
                    <template #cell(imagen)="{ item }">
                        <img :src="item.imagen" style="max-height: 100px">
                    </template> 
                    <template #cell(edad_media)="{ item }">
                        {{ item.edad_media ? item.edad_media + ' años' : '' }}
                    </template>
                </b-table>
            </div>
            <div class="m-3">
                <h2 class="pb-3">Listado de deportistas en el equipo</h2>
                <div class="row mb-3">
                    <div class="col-12 col-md-3 mb-1">
                        <SearchComponent v-model="search" />
                    </div>
                        <div class="col-12 col-md-3 mb-1">
                            <div class="input-group-sm" >
                                <select class="custom-select" id="search" v-model="search_for" @change="debouncedGetBases()">
                                    <option value="">Buscar por</option>
                                    <option value="nombre">Nombre</option>
                                    <option value="apellidos">Apellidos</option>
                                    <option value="dni">DNI</option>
                                    <option value="email">Email</option>
                                    <option value="dni_responsable">DNI responsable</option>
                                    <option value="email_responsable">Email responsable</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-3 mb-1">
                            <div class="input-group-sm">
                                <select class="custom-select " id="categorias" v-model="categoria" @change="debouncedGetBases()">
                                    <option value="">Categorias</option>
                                    <option v-for="categoria in categorias" :value="categoria.id" :key="categoria.id">{{categoria.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-md-3 mb-1">
                            <div class="input-group-sm">
                                <select class="custom-select" id="pago" v-model="metodo_pago" @change="debouncedGetBases()">
                                    <option value="">Metodo Pago</option>
                                    <option
                                        v-for="metodo_pago in metodos_pago_abonos_bases"
                                        :value="metodo_pago.id"
                                        :key="metodo_pago.id"
                                    >
                                        {{ metodo_pago.nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>
                </div>
                <div :class="['table', { 'expanded': bases.data.length <= 3 }]">
                    <b-table hover :items="bases.data" :fields="fields_deportistas" id="deportistas-equipos-table">
                        <template #cell(activo)></template>
                        <template #cell(opciones)="{ item, index }">
                            <OpcionesDropdownTableComponent
                                :lastIndex="bases.data.length > 3 && index >= bases.data.length - 3"
                                v-bind:options="[
                                    { to: { name: 'back.bases.show', params: { lista_id: lista_id, base_id: item.id } }, label: 'Ver deportista'},
                                ]"
                            />
                        </template>
                    </b-table>

                    <b-pagination
                        v-model="bases.meta.current_page"
                        :total-rows="bases.meta.total"
                        :per-page="per_page"
                        aria-controls="deportistas-equipos-table"
                        align="center"
                        @change="getBases"
                    ></b-pagination>
                </div>
            </div>
      </template>
    </MainContent>
</template>

<script>
import MainContent from '@/components/backend/components/MainContent';
import PageTitle from '@/components/backend/components/PageTitleComponent';
import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
import SearchComponent from "@/components/backend/components/SearchComponent";

export default {
    name: "DetalleIndumentaria",
    data() {
        return {
            equipo: null,
            bases: null,
            equipo_id: this.$route.params.equipo_id,
            loading: false,
            fields_equipos: [
                { key: 'nombre', label: 'Nombre', class: 'text-center' },
                { key: 'edad_media', label: 'Edad media', class: 'text-center' },
                { key: 'imagen', label: 'Imagen', class: 'text-center' },
            ],
            fields_deportistas: [
                { key: 'activo', label: '', tdClass: this.estaRenovadoCellClass },
                { key: "id", label: "ID"},
                { key: "nombre", label: "Nombre" },
                { key: "apellidos", label: "Apellidos" },
                { key: "dni", label: "DNI" }, 
                { key: "email", label: "Email" },
                { key: "tipo", label: "Tipo" },
                { key: "opciones", label: "Opciones", class: 'text-center' }
            ],
            items: null,
            per_page: 10,
            search: '',
            search_for: '',
            categoria: '',
            categorias: [],
            metodo_pago: ''
        }
    },
    created() {
        this.debouncedGetBases = _.debounce(this.getBases, 500);
        this.getEquipo();
        this.getBases(1);
        this.getCategorias();
        this.getMetodosPago();
    },
    methods: {
        getEquipo() {
            this.loading = true;

            const params = {
                lista_id: this.lista_id,
                equipo_id: this.equipo_id,
                filters: {}
            };

            this.$store.dispatch(this.config.getVuexAlias('back.bases.equipos.show'), params).then(res => {
                this.equipo = res.data.data;

                this.items = [{
                    nombre: this.equipo.nombre,
                    imagen: this.equipo.imagen_formatted,
                    edad_media: this.equipo.edad_media,
                }]

                this.loading = false;
            });
        },
        getBases(page) {
            const params = {
                filters: {
                    per_page: this.per_page,
                    page: page,
                    search: this.search,
                    search_for: this.search_for,
                    categoria: this.categoria,
                    metodo_pago: this.metodo_pago,
                    lista_id: this.lista_id
                },
                lista_id: this.lista_id,
                equipo_id: this.equipo_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.bases.equipos.get-bases'), params).then(res => {
                this.bases = res.data;
            });
        },
        estaRenovadoCellClass(value, key, item) {
            switch (value) {
            case 1:
                return 'bg-green';

            default:
                return 'bg-red';
            }
        },
        getCategorias(){
            let params = {
                filters: {},
                lista_id: this.lista_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.bases.get.categorias'), params).then(res => {
                this.categorias = res.data.data;
            });
        }
    },
    watch: {
        "search"() {
            this.debouncedGetBases();
        },
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        metodos_pago_abonos_bases() {
            const { metodos_pago_abonos_bases } = this.teatro;

            return metodos_pago_abonos_bases;
        },
        lista_id() {
            return this.$route.params.lista_id;
        }
    },
    components: {
        MainContent, PageTitle, OpcionesDropdownTableComponent, SearchComponent
    }
}
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>